module.exports = {"data":{"site":{"siteMetadata":{"title":"tkdev"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 81
// module chunks = 60335399758886 114276838955818